export default __webpack_public_path__ + "259b67e926f59e835315e7af94e9fcb0.ttf";